import React from 'react';
import { Box, PaginationBar, Preloader } from '@common-fe/common-fe';

import { DefaultSortTypesEnum } from '@/common/types';
import { useListPagination } from '@/modules/employer/hooks';

import { useGetContributionChangesets } from './queries/useGetContributionChangesets.query';
import { ChangeSet, DEFAULT_PER_PAGE, PER_PAGE_OPTIONS } from './ChangeSet';

const DEFAULT_SORT = `changedAt,${DefaultSortTypesEnum.DESC}`;

interface Props {
  requestId?: string;
}

export const ChangesSetsList: React.FC<Props> = ({ requestId }) => {
  const {
    page,
    perPage,
    setPerPage,
    setPage,
  } = useListPagination(DEFAULT_PER_PAGE);
  const { isLoading, formattedData: {
    content: changesSets,
    totalElements,
  } } = useGetContributionChangesets(requestId, { size: perPage, page, sort: DEFAULT_SORT });

  return (
    <Box
      data-testId={`ChangesSetsList_for_request_${requestId}`}
    >
      {isLoading
        ? <Box margin={{ top: 'spacing16' }}><Preloader /></Box>
        : changesSets?.map((changesSet) => <ChangeSet key={changesSet?.id} changeSet={changesSet} />)}

      {totalElements && totalElements > DEFAULT_PER_PAGE ? (
          <PaginationBar
            page={page}
            total={totalElements || 0}
            pageSize={perPage}
            onChangePage={setPage}
            onChangePageSize={setPerPage}
            perPageOptions={PER_PAGE_OPTIONS}
          />
        ) : null}
    </Box>
  );
};
